import { useStandardPriceForm } from './useStandardPriceForm'
import {
  PriceField,
  InputSelectControlField,
  TextInputField,
  Box,
  Flex
} from '@sequencehq/core-components'
import { Currency } from '@sequencehq/api'
import { PricingModelField } from '../common/PricingModelField'
import { ExternalLedgerForm } from '../common/ExternalLedgerForm/ExternalLedgerForm'
import { BillingTypeField } from '../common/BillingTypeField'
import { BillingFrequencyField } from '../common/BillingFrequencyField'
import { ProductSelectField } from '../common/ProductSelectField'

export const StandardPriceForm = () => {
  const { fieldsConfig } = useStandardPriceForm()

  return (
    <>
      <Flex direction="column" gap="16px">
        <ProductSelectField />

        <PricingModelField />

        <TextInputField
          label="Display name (appears on invoice)"
          data-testid="standard.name"
          value={fieldsConfig.name.value}
          onChange={e => fieldsConfig.name.onChange(e.target.value)}
          validationErrors={fieldsConfig.name.validationErrors}
          isDisabled={fieldsConfig.name.disabled}
          placeholder="Enter a display name"
        />

        <BillingFrequencyField
          data-testid="standard.billingFrequency"
          value={fieldsConfig.billingFrequency.value}
          options={fieldsConfig.billingFrequency.options}
          onChange={fieldsConfig.billingFrequency.onChange}
          validationErrors={fieldsConfig.billingFrequency.validationErrors}
          isDisabled={fieldsConfig.billingFrequency.disabled}
        />

        <BillingTypeField
          value={fieldsConfig.billingType.value}
          onChange={newValue => {
            fieldsConfig.billingType.onChange(newValue)
          }}
          isDisabled={fieldsConfig.billingType.disabled}
          data-testid="standard.billingType"
        />

        <Flex gap="4px" alignItems="flex-start">
          <PriceField
            label="Price"
            data-testid="standard.price"
            value={fieldsConfig.price.value}
            onChange={newValue => fieldsConfig.price.onChange(newValue)}
            validationErrors={fieldsConfig.price.validationErrors}
            currency={fieldsConfig.currency.value}
            isDisabled={fieldsConfig.price.disabled}
            borderTopRightRadius={0}
            borderBottomRightRadius={0}
            variant="v2"
          />
          {!fieldsConfig.currency.hidden && (
            <Box paddingTop="24px" minHeight="72px">
              <InputSelectControlField
                data-testid="standard.currency"
                value={fieldsConfig.currency.value}
                onChange={newCurrency =>
                  fieldsConfig.currency.onChange(newCurrency as Currency)
                }
                options={fieldsConfig.currency.options}
                validationErrors={fieldsConfig.currency.validationErrors}
                disabled={fieldsConfig.currency.disabled}
                placeholder="Select currency"
                width="150px"
              />
            </Box>
          )}
        </Flex>

        <ExternalLedgerForm />
      </Flex>
    </>
  )
}
